import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  DialogContentText, Button, Box, CircularProgress
} from '@mui/material';

const DynamicModal = ({
  open = false,
  title = "",
  children,
  onClose,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  maxWidth = "sm",
  fullWidth = true,
  hideActions = false,
  contentText = ""
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {contentText && <DialogContentText>{contentText}</DialogContentText>}
        <Box sx={{ mt: 2 }}>{children}</Box>
      </DialogContent>
      {!hideActions && (
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            <h4 style={{color:'green'}}>{cancelText}</h4>
          </Button>
          {onConfirm && (
            <Button 
              onClick={onConfirm} 
              variant="contained" 
              disabled={loading}
              style={{backgroundColor:"green"}}
              startIcon={loading && <CircularProgress size={20} />}
            >
              {loading ? 'Processing...' : confirmText}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DynamicModal;
